export default __webpack_public_path__ + "static/media/Maduro-2Closed.aa9246fd.jpg";